import { render, staticRenderFns } from "./HomepageTestimonials.vue?vue&type=template&id=00ad7e18&"
import script from "./HomepageTestimonials.vue?vue&type=script&lang=js&"
export * from "./HomepageTestimonials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports